.legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-4);
}

.below {
  justify-content: center;
  padding-top: var(--space-4);
}

.header {
  justify-content: flex-end;
}

.item {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-md);
  color: var(--text-secondary);
}

.swatch {
  flex-shrink: 0;
}

.square {
  width: 11px;
  height: 11px;
  border-radius: 3px;
  background: var(--color);
}

.line {
  width: 16px;
  height: 2px;
  border-radius: 1px;
  background: var(--color);
}

.dash {
  width: 16px;
  height: 0;
  border-top: 2px dashed var(--color);
}

/* Hatched key for "Not Available" fills — same ground and stripe as the in-chart pattern */
.hatch {
  width: 13px;
  height: 13px;
  border-radius: 3px;
  background-color: var(--bg-elevated);
  background-image: repeating-linear-gradient(
    135deg,
    var(--color) 0,
    var(--color) 2px,
    transparent 2px,
    transparent 6px
  );
}

.note {
  font-size: var(--text-sm);
  color: var(--text-muted);
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--color);
}
